import gql from "graphql-tag";

const listDaerah = gql`
  query daerahList($nama_daerah: String) {
    daerahList(where: { nama_daerah: $nama_daerah }) {
      id
      kod_daerah
      nama_daerah
      negeri_id
      status
    }
  }
`;

const viewDaerah = gql`
  query daerahView($id: Float!) {
    daerahView(id: $id) {
      id
      kod_daerah
      nama_daerah
      negeri_id
      status
    }
  }
`;

const createDaerah = gql`
  mutation daerahCreate($input: CreateDaerahDto!) {
    daerahCreate(input: $input) {
      id
      kod_daerah
      nama_daerah
      negeri_id
      status
    }
  }
`;

const updateDaerah = gql`
  mutation daerahUpdate($input: UpdateDaerahDto!) {
    daerahUpdate(input: $input) {
      id
      kod_daerah
      nama_daerah
      negeri_id
      status
    }
  }
`;

const deleteDaerah = gql`
  mutation daerahDelete($input: Float!) {
    daerahDelete(id: $input)
  }
`;

export { listDaerah, viewDaerah, createDaerah, updateDaerah, deleteDaerah };